// extracted by mini-css-extract-plugin
export var originalPrice = "_vi-0";